"use client";

import { FC, useState } from "react";
import Link from "next/link";
import { Drawer } from "vaul";
import { PHONE_NUMBER_ECOGOLD } from "../constants";
import { cn } from "../utils";
import { BookIcon, Bubbles2MessagesIcon, CallPhoneIcon, HeadphoneIcon } from "./icons";
type THelpButtonProps = {
  iconClassName?: string;
};
const HelpButton: FC<THelpButtonProps> = props => {
  const {
    iconClassName
  } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  return <Drawer.Root onOpenChange={setIsOpen} open={isOpen} data-sentry-element="unknown" data-sentry-component="HelpButton" data-sentry-source-file="HelpButton.tsx">
      <Drawer.Trigger data-sentry-element="unknown" data-sentry-source-file="HelpButton.tsx">
        <div className="flex h-full items-center justify-center">
          <HeadphoneIcon className={cn("size-6", iconClassName)} data-sentry-element="HeadphoneIcon" data-sentry-source-file="HelpButton.tsx" />
        </div>
      </Drawer.Trigger>
      <Drawer.Portal data-sentry-element="unknown" data-sentry-source-file="HelpButton.tsx">
        <Drawer.Overlay className="fixed inset-0 z-40 bg-black/40 " data-sentry-element="unknown" data-sentry-source-file="HelpButton.tsx" />
        <Drawer.Content className="container fixed inset-x-0 bottom-0 z-50 flex h-fit flex-col rounded-t-3xl  bg-white pt-2  outline-none" data-sentry-element="unknown" data-sentry-source-file="HelpButton.tsx">
          <div className="mb-10 mt-4 flex flex-col items-center justify-center gap-4">
            <Drawer.Title className="flex flex-col items-center justify-center gap-1" data-sentry-element="unknown" data-sentry-source-file="HelpButton.tsx">
              <p className="text-xl font-semibold text-gray-800">
                پشتیبانی اکوگلد
              </p>
            </Drawer.Title>
            {/* TODO: fix support button */}
            <div className="mt-2 flex w-full items-center justify-center">
              <Link href="/questions" className="flex w-1/3 flex-col items-center justify-center gap-4" data-sentry-element="Link" data-sentry-source-file="HelpButton.tsx">
                <BookIcon className="size-12" data-sentry-element="BookIcon" data-sentry-source-file="HelpButton.tsx" />
                <p className="text-sm font-semibold text-gray-700">
                  سوالات متداول
                </p>
              </Link>

              <Link href="tel:82800860" className="relative flex w-1/3 flex-col items-center justify-center gap-4 md:hidden" data-sentry-element="Link" data-sentry-source-file="HelpButton.tsx">
                <div className="absolute left-0 top-0 rounded-lg bg-gradient-to-r from-[#FFAE00] to-[#FFCE00] px-2">
                  <p className="text-2xs font-semibold text-gray-800">
                    به زودی
                  </p>
                </div>
                <CallPhoneIcon className="size-12" data-sentry-element="CallPhoneIcon" data-sentry-source-file="HelpButton.tsx" />
                <p className="text-sm font-semibold text-gray-700">
                  تماس پشتیبانی
                </p>
              </Link>
              <div className="relative hidden w-1/3 flex-col items-center justify-center gap-4 md:flex">
                <div className="absolute left-0 top-0 rounded-lg bg-gradient-to-r from-[#FFAE00] to-[#FFCE00] px-2">
                  <p className="text-2xs font-semibold text-gray-800">
                    به زودی
                  </p>
                </div>
                <CallPhoneIcon className="size-12" data-sentry-element="CallPhoneIcon" data-sentry-source-file="HelpButton.tsx" />
                <p className="text-center text-sm font-semibold text-gray-700">
                  {PHONE_NUMBER_ECOGOLD}
                </p>
              </div>

              <div onClick={() => {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              Goftino.open();
            }} className="flex w-1/3 cursor-pointer flex-col items-center justify-center gap-4">
                <Bubbles2MessagesIcon className="size-12" data-sentry-element="Bubbles2MessagesIcon" data-sentry-source-file="HelpButton.tsx" />
                <p className="text-sm font-semibold text-gray-700">چت آنلاین</p>
              </div>
            </div>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>;
};
export default HelpButton;